const capitalizeString = (str: string) => {
  return str.replace(/^\w/, c => c.toUpperCase())
}

export {
  capitalizeString
}
